/** BSC 主网代币与合约地址 */
export const USDT_ADDRESS = "0x55d398326f99059fF775485246999027B3197955";
export const RAD_ADDRESS = "0xAbB0EDEeD1996C73C6B2E23a4d4B7e303B6906ab";
export const LP_ADDRESS = "0x4957836cbd968A34c98CcBEd256E0f8642c00653"
export const RUSD_ADDRESS = "0xc193ee56929adaa9232e2662a83cb62b45a41b26"
// 正式版
// export const LOTTERY_ADDRESS = "0x6A1d13Db8B2092974b68F002Ab68a85E4Ba27128";
// export const STAKE_ADDRESS = "0x9697582d3b0aDD3c739dA55355515f24C296b725";
// export const NFTS_ADDRESS = "0x675814E8e334C8a262F0355f67A524Ad24f56e15"
// export const STAKE_PATCH_ADDRESS = "0x9De26CadB935bcC38Aa492e0117DeE12be2205e0"
// export const RAD_STAKE_ADDRESS = "0x0706BE0964f1E00a0eAD95785be0ECE7612cc7D5"
// 测试版
export const LOTTERY_ADDRESS = "0x12484D2f4ed1C78B6c9F8F24ca29d83b116eBb75";
export const STAKE_ADDRESS = "0x054D6EC709d1fd10926f3BF76038617a45BF5815";
export const NFTS_ADDRESS = "0x8B1556Db71c259ec08e49131Ab4CD2C5dd3Eb93F"
export const STAKE_PATCH_ADDRESS = "0xCe4319dACA81CcD0D7838EEA33e1D0b410993d70"
export const RAD_STAKE_ADDRESS = "0xC38840AfADF47d5d9A09a4669525E920623bb8b1"



/** 前端路由 id → 合约 CardType 枚举 (NONE=0, GOLDEN=1, SILVER=2, BRONZE=3) */
export const FRONTEND_TO_CARD_TYPE = { 1: 2, 2: 1, 3: 3 };

export const CARD_TYPE_LABELS = { 1: "金卡", 2: "银卡", 3: "铜卡" };

export const CARD_TYPE_EMOJI = { 1: "🥇", 2: "🥈", 3: "🥉" };

/** 合约 CardType → 首页盲盒卡片静态配置 */
export const HOME_BLIND_BOX_META = [
  {
    cardType: 1,
    id: 2,
    namePrefix: "RAD金卡",
    displayPrice: 30000,
    image: require("@/assets/image/rad_card2.png"),
  },
  {
    cardType: 2,
    id: 1,
    namePrefix: "RAD银卡",
    displayPrice: 20000,
    image: require("@/assets/image/rad_card1.png"),
  },
  {
    cardType: 3,
    id: 3,
    namePrefix: "RAD铜卡",
    displayPrice: 10000,
    image: require("@/assets/image/rad_card3.png"),
  },
];

export const TOKEN_DECIMALS = 18;

export const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";

export function getCardTypeByFrontendId(frontendId) {
  const cardType = FRONTEND_TO_CARD_TYPE[Number(frontendId)];
  if (!cardType) {
    throw new Error(`无效的盲盒 id: ${frontendId}`);
  }
  return cardType;
}

/** NFT tokenId 区间 → 卡牌类型 */
export function getCardLevelByTokenId(tokenId) {
  const id = Number(tokenId);
  if (id >= 1 && id <= 2000) return "gold";
  if (id >= 2001 && id <= 7000) return "silver";
  if (id > 7000) return "bronze";
  return null;
}
